export default __webpack_public_path__ + "static/media/suite-montanha1-5.0119dca9.jpg";